module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('x-header', {
    attrs: {
      "upload": "true"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'liveDetail',
        params: {
          liveId: this.$route.params.liveId
        }
      }
    }
  }, [_c('div', {
    staticClass: "backHome"
  }, [_c('h1', [_vm._v("主会场\n        "), _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-jiantou1"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover",
    style: ({
      backgroundImage: ("url('" + (_vm.live.Banner) + "')")
    })
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "cc"
  }, [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tongzhi"
    }
  })]), _vm._v(" "), _c('marquee', {
    attrs: {
      "id": "affiche",
      "align": "left",
      "behavior": "scroll",
      "direction": "left",
      "height": "16",
      "width": "100%",
      "hspace": "40",
      "vspace": "7",
      "loop": "loop",
      "scrollamount": "5",
      "scrolldelay": "100"
    }
  }, [_vm._v("\n          拍摄上传你认为的现场大片，参与现场互动\n        ")])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'userIndex',
        params: {
          liveId: this.$route.params.liveId
        }
      }
    }
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: ("url('" + (_vm.user.Avatar) + "')")
    })
  })])], 1), _vm._v(" "), _c('interaction-list', {
    staticClass: "list"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c367584c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/live/Interaction.vue
// module id = 535
// module chunks = 1